module.exports = (s) => {
  return [
    {
      name: '广告主账户',
      value: 'advertiser_id',
    },
    {
      name: '创意名称',
      value: 'name',
    },
    {
      name: '创意ID',
      value: 'id',
    },
    {
      name: '状态',
      format: ({ status }) => {
        return s.enum_map.status[status];
      },
    },
    {
      name: '素材',
      format: ({ videos = [], images = [] }) => {
        return `视频:${videos.length} 图片:${images.length}`;
      },
    },
    {
      name: '标题',
      format: ({ titles = [] }) => {
        return titles.length ? titles[0] : '-';
      },
    },
    {
      name: '落地页',
      format: ({ sites = [] }) => {
        return sites.length ? sites[0].name : '-';
      },
    },
    {
      name: '操作',
      width: 120,
      format: (row) => {
        const { status } = row;
        const is_enable = status === 'ENABLE';
        const h = s.$createElement;
        const ele = h('div', null, [
          h('el-link', {
            props: {
              type: 'primary',
              underline: false,
            },
            on: {
              click: () => {
                s.onEdit(row);
              },
            },
          },
          '编辑'),
          h('el-link', {
            class: 'ml-5',
            props: {
              type: is_enable ? 'info' : 'success',
              underline: false,
            },
            on: {
              click: () => {
                s.onSwitch(row);
              },
            },
          },
          is_enable ? '关闭' : '开启'),
          h('el-link', {
            class: 'ml-5',
            props: {
              type: 'danger',
              underline: false,
            },
            on: {
              click: () => {
                const { id } = row;
                s.onDel([id]);
              },
            },
          },
          '删除'),
        ]);

        return ele;
      },
    },
  ];
};
